/*!
 * chq-collection-stars.js
 * v1.0 — 2026-09-10
 * Collection-safe cleanup for BayEngage product-list aggregate ratings.
 *
 * Liquid always emits one #bulk_reviews_{id} per card so BayEngage can inject
 * for products it knows have reviews (targetbay metafields are stale).
 * When show_ratings_if_exists is false, BayEngage also paints 0.0 on zero-review
 * cards — strip those so empty cards stay clean.
 *
 * Scope: collection / search only (same guard as chq-collection-bss.js).
 * Not loaded on homepage.
 */
(function () {
  'use strict';

  function isCollectionScope() {
    var b = document.body;
    if (!b) return false;
    if (b.classList.contains('product')) return false;
    if (b.classList.contains('template-product')) return false;
    if (b.classList.contains('collection')) return true;
    if (b.classList.contains('template-collection')) return true;
    if (b.classList.contains('search')) return true;
    if (b.classList.contains('template-search')) return true;
    if (document.querySelectorAll('.product__thumbnail, .product-wrap').length >= 2) return true;
    return false;
  }

  function cardRoot(el) {
    return el.closest('.product__thumbnail') ||
           el.closest('.product-wrap') ||
           el.closest('[data-product-id]') ||
           null;
  }

  function isZeroWidget(node) {
    if (!node || !node.querySelector) return false;
    // Prefer BayEngage data attrs on ._tbr_col_stat
    var host = node.classList && node.classList.contains('_tbr_col_stat')
      ? node
      : (node.closest && node.closest('._tbr_col_stat')) || node;
    var rc = host.getAttribute && host.getAttribute('data-review-count');
    var rating = host.getAttribute && host.getAttribute('data-rating');
    if (rc !== null && rc !== undefined && rc !== '') {
      var n = parseInt(rc, 10);
      if (!isNaN(n) && n === 0) return true;
    }
    if (rating !== null && rating !== undefined && rating !== '') {
      var r = parseFloat(rating);
      if (!isNaN(r) && r === 0) return true;
    }
    // Visible "0.0" rating text
    var val = host.querySelector && host.querySelector('._tbr-statistics-rating-value');
    if (val) {
      var t = (val.textContent || '').trim();
      if (t === '0.0' || t === '0' || t === '0.00') return true;
    }
    // Whole-widget text fallback (avoid killing non-zero)
    var widget = host.querySelector && host.querySelector('._tbr-collection-statistics-widget, ._tbr-statistics-widget');
    if (widget) {
      var wt = (widget.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^0\.0\b/.test(wt) || wt === '0.0') return true;
    }
    return false;
  }

  function clearZero(node) {
    var host = node.classList && node.classList.contains('_tbr_col_stat')
      ? node
      : (node.closest && node.closest('._tbr_col_stat')) || node;
    var bulk = host.closest && host.closest('.bulk-reviews');
    try {
      if (bulk) {
        bulk.innerHTML = '';
        bulk.style.display = 'none';
        bulk.setAttribute('data-chq-stars-cleared', '1');
      } else if (host && host.parentNode) {
        host.remove();
      }
    } catch (e) { /* ignore */ }
  }

  function sweep() {
    if (!isCollectionScope()) return;
    var nodes = document.querySelectorAll(
      '.product__thumbnail ._tbr_col_stat, .product__thumbnail ._tbr-collection-statistics-widget, ' +
      '.product-wrap ._tbr_col_stat, .product-wrap ._tbr-collection-statistics-widget, ' +
      '.bulk-reviews ._tbr_col_stat, .bulk-reviews ._tbr-collection-statistics-widget'
    );
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (isZeroWidget(n)) clearZero(n);
    }
    // Also hide empty bulk shells that somehow got a lone 0.0 text node
    var bulks = document.querySelectorAll('.product__thumbnail .bulk-reviews, .product-wrap .bulk-reviews');
    for (var j = 0; j < bulks.length; j++) {
      var b = bulks[j];
      if (b.getAttribute('data-chq-stars-cleared') === '1') continue;
      var txt = (b.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt === '0.0' || txt === '0') {
        b.innerHTML = '';
        b.style.display = 'none';
        b.setAttribute('data-chq-stars-cleared', '1');
      }
    }
  }

  function start() {
    if (!isCollectionScope()) return;
    if (window.__chqCollectionStarsBound) return;
    window.__chqCollectionStarsBound = true;

    sweep();
    // BayEngage injects after its own deferred scripts; catch late paints
    var delays = [0, 200, 500, 1000, 2000, 4000, 7000, 10000];
    for (var i = 0; i < delays.length; i++) {
      setTimeout(sweep, delays[i]);
    }

    var deadline = Date.now() + 12000;
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (Date.now() > deadline) {
        try { obs.disconnect(); } catch (e) {}
        return;
      }
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        sweep();
      });
    });
    try {
      obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
    setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', function () { setTimeout(start, 0); });
})();
